define('CCSearch', [
  'SearchModules',
	'PartLookup',
], function (
	SearchModules,
	PartLookup,
) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {

      // replaces native global search with one that includes model/part search input
      SearchModules.mountToApp(application);

      // all logic connected to part lookup
      PartLookup.mountToApp(application);

		}
	};
});
